import React from 'react'
import { Route, Routes, useParams } from 'react-router-dom'

import Course from './Course'
import PageNotFound from './PageNotFound'
import Home from './Home'
import Imprint from './Imprint'
import CoursesOverview from '../Components/CoursesOverview/CoursesOverview'
import UserSettings from './UserSettings'
import PublishedCourseOverview from './PublishedCourseOverview'
import CoursePublishPreparation from './CoursePublishPreparation'
import StatisticsOverview from '../Components/Statistics/StatisticsOverview'
import ClientSettings from './ClientSettings'

const ProtectedRoutes: React.FC = () => {
  const { courseId } = useParams<{ courseId: string }>()

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/courses-overview" element={<CoursesOverview />} />
      <Route path="/course/:id" element={<Course id={courseId} />}/>
      <Route path="/user-settings" element={<UserSettings />} />
      <Route path="/client-settings" element={<ClientSettings />} />
      <Route path="/imprint" element={<Imprint />} />
      <Route path="/published-course/:id" element={<PublishedCourseOverview />} />
      <Route path="/course-publish-preparation/:id" element={<CoursePublishPreparation />} />
      <Route path="/statistics-overview" element={<StatisticsOverview />} />
      <Route path="/statistics/:courseId" element={<div>Statistics for specific course!</div>} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  )
}

export default ProtectedRoutes